import {
    API_ENDPOINT,
    getLocalTimeHeader,
    getSearchParamsString,
} from './api';
import { SEND_METHOD } from 'enums/MemberVerification';

const urlSendVerificationCode = '/Member/SendVerificationCode';
const urlVerifyCode = '/Member/CheckVerificationCode';

const sendVerificationCode = async (phoneNumber: string, channel: SEND_METHOD) => {
    const url = `${API_ENDPOINT}${urlSendVerificationCode}?${getSearchParamsString(
        {
            phoneNumber,
            channel,
        }
        )}`;

    return await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...getLocalTimeHeader(),
        }
    }).then((response) => response.json());
};

const verifyCode = async (phoneNumber: string, verificationCode: string) => {
    const url = `${API_ENDPOINT}${urlVerifyCode}?${getSearchParamsString(
        {
            phoneNumber,
            verificationCode,
        }
    )}`;

    return await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...getLocalTimeHeader(),
        },
    }).then((response) => response.json());
};

export { sendVerificationCode, verifyCode };